import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "x-icon",
  "use": "x-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"x-icon\">\r\n<path d=\"M13.7125 10.6218L20.4134 3H18.8254L13.007 9.61788L8.35992 3H3L10.0274 13.0074L3 21H4.58799L10.7324 14.0113L15.64 21H21L13.7125 10.6218ZM11.5375 13.0956L10.8254 12.0991L5.16016 4.16971H7.59922L12.1711 10.5689L12.8832 11.5654L18.8262 19.8835H16.3871L11.5375 13.0956Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol